/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit, Input, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, hospitalTypes } from '../../../shared/constants';
import Swal from 'sweetalert2';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'hospital-form',
	templateUrl: './hospital-form.component.html',
	styleUrl: './hospital-form.component.scss'
})
export class HospitalFormComponent implements OnInit {
	moduleForm: FormGroup = this.formBuilder.group({
		name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		address: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		country_code: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		phone_number: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
		email: [null, [/* Validators.required, noWhitespaceInRequiredValidator,  */Validators.pattern(emailPattern)]],
		country: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		state: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		city: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		type: [null]
	});
	showLoader = false;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	countryCodes: any = [];
	countryList: any = [];
	stateList: any = [];
	cityList: any = [];
	hospitalTypes = hospitalTypes;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCountryCodes();
		this.getCountryList();
		if (this.uId) {
			this.getDetails();
		} else {
			this.f.country_code.setValue("+91");
			this.f.country.setValue("IND");
			this.getStatesByCountry();
		}
	}

	getCountryCodes() {
		this.pageLoading3 = true;
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + "(" + c.name + ")"
					return c;
				})
				this.countryCodes = data;
				this.pageLoading3 = false;
			}, error: () => {
				this.countryCodes = [];
				this.pageLoading3 = false;
			}
		});
	}

	getCountryList() {
		this.pageLoading2 = true;
		this.apiService.country().subscribe({
			next: (data: any) => {
				this.countryList = data;
				this.pageLoading2 = false;
			}, error: () => {
				this.countryList = [];
				this.pageLoading2 = false;
			}
		});
	}

	getStatesByCountry() {
		if (this.f.country.value) {
			this.apiService.stateList(this.f.country.value).subscribe({
				next: (data: any) => {
					this.stateList = [...data];
					if (this.f.state.value) {
						if (!this.stateList.find((doc) => doc.stateID == this.f.state.value)) {
							this.f.state.setValue(null);
						}
					}
				}, error: () => {
					this.stateList = [];
					this.f.state.setValue(null);
				}
			});
		} else {
			this.stateList = [];
			this.f.state.setValue(null);
		}
	}

	getCitiesByState() {
		if (this.f.state.value) {
			this.apiService.cityList(this.f.state.value).subscribe({
				next: (data: any) => {
					this.cityList = [...data];
					if (this.f.city.value) {
						if (!this.cityList.find((doc) => doc.cityID == this.f.city.value)) {
							this.f.city.setValue(null);
						}
					}
				}, error: () => {
					this.cityList = [];
					this.f.city.setValue(null);
				}
			});
		} else {
			this.cityList = [];
			this.f.city.setValue(null);
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getHospital({ id: this.uId }).subscribe({
			next: (data: any) => {
				const obj = data.data;
				this.f.name.setValue(obj.name);
				this.f.address.setValue(obj.address);
				this.f.type.setValue(obj.type);
				this.f.country_code.setValue(obj.country_code);
				this.f.phone_number.setValue(obj.phone_number);
				this.f.email.setValue(obj.email);
				this.f.country.setValue(obj.country);
				this.f.state.setValue(obj.state ? parseInt(obj.state) : null);
				this.f.city.setValue(obj.city ? parseInt(obj.city) : null);
				this.getStatesByCountry();
				this.getCitiesByState();
				this.pageLoading1 = false;
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			name: this.f.name.value,
			address: this.f.address.value,
			type: this.f.type.value,
			country_code: this.f.country_code.value,
			phone_number: this.f.phone_number.value,
			email: this.f.email.value,
			country: this.f.country.value,
			state: this.f.state.value,
			city: this.f.city.value,
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateHospital(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "Hospital already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	addCity(cityName: any) {
		if (!cityName) {
			this.toastr.error("Please enter city name", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!this.f.state.value) {
			this.toastr.error("Please select state", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to create city <strong>' + cityName + '</strong>?',
			icon: 'question',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Create',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.apiService.createUpdateCity({ state_id: this.f.state.value, name: cityName }).subscribe({
					next: (data) => {
						this.toastr.success("City created successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.f.city.setValue(data);
						this.getCitiesByState();
					}, error: (error) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}
}
